<template>
  <div>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headersValores"
          :items="itemValores"
          class="elevation-1 w-100 proposta"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.investimentoTotal="{ item }">
            {{
              item.investimentoTotal &&
              item.investimentoTotal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>

          <template v-slot:item.contrapartidaSebrae="{ item }">
            {{
              item.contrapartidaSebrae &&
              item.contrapartidaSebrae.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>

          <template v-slot:item.investimentoMunicipal="{ item }">
            {{
              item.investimentoMunicipal &&
              item.investimentoMunicipal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "TabelaValoresPropostaMA",
  props: {
    payload: { type: Object, required: true },
    faixa: { type: Object, default: null },
    combos: { type: Array, default: () => [] },
    atualCombo: { type: Object, default: null },
    solucoesPacote: { type: Array, default: () => [] },
  },
  data() {
    return {
      headersValores: [
        { text: "", value: "combo", sortable: false },
        {
          text: "Investimento Total",
          value: "investimentoTotal",
          sortable: false,
        },
        {
          text: "Contrapartida Sebrae",
          value: "contrapartidaSebrae",
          sortable: false,
        },
        {
          text: "Investimento Municipal",
          value: "investimentoMunicipal",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    getTotalPacote() {
      return this.payload.solucoesFaixasDTO
        .filter((item) => this.solucoesPacote.includes(item.solucaoId + ""))
        .reduce((partialSum, a) => {
          return partialSum + (a.precoFaixa || a.preco || 0);
        }, 0);
    },

    getValorContrapartidaSebraePacote() {
      const valorComSubsidio = this.getTotalPacote * (this.faixaSubsidio / 100);

      return valorComSubsidio;
    },
    getValorInvestimentoMunicipalPacote() {
      const valorComSubsidio =
        this.getTotalPacote * ((100 - this.faixaSubsidioPreium) / 100);

      return valorComSubsidio;
    },
    getTotalAvulsaSemExtra() {
      return this.payload.solucoesFaixasDTO
        .filter((item) => !this.solucoesPacote.includes(item.solucaoId + ""))
        .filter((item) => item.solucaoId || item.idSolucao)
        .reduce((partialSum, a) => {
          return partialSum + (a.precoFaixa || a.preco || 0);
        }, 0);
    },

    getValorContrapartidaSebraeAvulsa() {
      const valorComSubsidio =
        this.getTotalAvulsaSemExtra * (this.faixaSubsidio / 100);

      return valorComSubsidio;
    },
    getValorInvestimentoMunicipalAvulsa() {
      const valorComSubsidio =
        this.getTotalAvulsaSemExtra * ((100 - this.faixaSubsidioPreium) / 100);

      return valorComSubsidio;
    },
    getSomaSolucoes() {
      return this.payload.solucoesFaixasDTO.reduce((partialSum, a) => {
        return partialSum + (a.precoFaixa || a.preco || 0);
      }, 0);
    },
    getSomaSolucoesSemExtra() {
      return this.payload.solucoesFaixasDTO
        .filter((item) => item.solucaoId || item.idSolucao)
        .reduce((partialSum, a) => {
          return partialSum + (a.precoFaixa || a.preco || 0);
        }, 0);
    },

    faixaSubsidioPreium() {
      return (this.atualCombo && this.atualCombo.combo.subsidio) || 0;
    },
    faixaSubsidio() {
      return (this.atualCombo && this.atualCombo.combo.subsidio) || 0;
    },
    getValorTotal() {
      return (
        this.getSomaSolucoesSemExtra + this.getValorSolucoesExtra.valorTotal
      );
    },

    getValorContrapartidaSebrae() {
      const valorComSubsidio =
        this.getSomaSolucoesSemExtra * (this.faixaSubsidio / 100);

      return valorComSubsidio + this.getValorSolucoesExtra.valorSebrae;
    },
    getValorInvestimentoMunicipal() {
      const valorComSubsidio =
        this.getSomaSolucoesSemExtra * ((100 - this.faixaSubsidio) / 100);

      return valorComSubsidio + this.getValorSolucoesExtra.valorMunicipio;
    },
    getValorSolucoesExtra() {
      const extras = this.payload.solucoesFaixasDTO.filter(
        (item) => item.municipioPropostaSolucoesExtrasId
      );

      return {
        valorTotal: extras.reduce((partialSum, a) => {
          return partialSum + (a.preco || 0);
        }, 0),
        valorMunicipio: extras.reduce((partialSum, a) => {
          return partialSum + (a.valorMunicipio || 0);
        }, 0),
        valorSebrae: extras.reduce((partialSum, a) => {
          return partialSum + (a.valorSebrae || 0);
        }, 0),
      };
    },
    getValorContrapartidaSebraeSemExtra() {
      const valorComSubsidio =
        this.getSomaSolucoesSemExtra * (this.faixaSubsidio / 100);

      return valorComSubsidio;
    },
    getValorInvestimentoMunicipalSemExtra() {
      const valorComSubsidio =
        this.getSomaSolucoesSemExtra * ((100 - this.faixaSubsidio) / 100);

      return valorComSubsidio;
    },
    getValorTotalSemExtra() {
      return this.getSomaSolucoesSemExtra;
    },
    itemValores() {
      let valores = [
        {
          combo: "Total pacote",
          investimentoTotal: this.getTotalPacote,
          contrapartidaSebrae: this.getValorContrapartidaSebraePacote,
          investimentoMunicipal: this.getValorInvestimentoMunicipalPacote,
        },
        {
          combo: "Total avulsas sem extra",
          investimentoTotal: this.getTotalAvulsaSemExtra,
          contrapartidaSebrae: this.getValorContrapartidaSebraeAvulsa,
          investimentoMunicipal: this.getValorInvestimentoMunicipalAvulsa,
        },
      ];

      if (this.getValorSolucoesExtra.valorTotal > 0)
        valores.push(
          {
            combo: "Extra",
            investimentoTotal: this.getValorSolucoesExtra.valorTotal,
            contrapartidaSebrae: this.getValorSolucoesExtra.valorSebrae,
            investimentoMunicipal: this.getValorSolucoesExtra.valorMunicipio,
          },
          {
            combo: "Total sem Extras",
            investimentoTotal: this.getValorTotalSemExtra,
            contrapartidaSebrae: this.getValorContrapartidaSebraeSemExtra,
            investimentoMunicipal: this.getValorInvestimentoMunicipalSemExtra,
          }
        );

      valores = [
        ...valores,

        {
          combo: "Total",
          investimentoTotal: this.getValorTotal,
          contrapartidaSebrae: this.getValorContrapartidaSebrae,
          investimentoMunicipal: this.getValorInvestimentoMunicipal,
        },
      ];

      return valores;
    },
  },
};
</script>
